export default "__VITE_PUBLIC_ASSET__0069bc34__"